import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { Grid } from '@mui/material'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import Typography from '../../../atoms/typography'
import { AdditionalText, ButtonStyled, DialogStyled } from './need-help.styled'
import Link from '../../../molecules/link/link'

const NeedHelp = () => {
	const { formatMessage } = useIntl()
	const [toggleDialog, setToggleDialog] = useState(false)
	const { siteTelephone } = useConfig()

	const {
		catalog: {
			products: {
				needHelpLink: { enabled: needHelpLinkEnabled },
			},
		},
	} = useConfig()

	return (
		needHelpLinkEnabled && (
			<>
				<ButtonStyled variant="text" onClick={() => setToggleDialog(true)}>
					{formatMessage({ id: 'need_help_link' })}
				</ButtonStyled>
				<DialogStyled showButtonClose open={toggleDialog} onClose={() => setToggleDialog(false)}>
					<Grid alignItems="center" display="flex" flexDirection="column">
						<Typography variant="h1" component="h2" mb={4} textAlign="center">
							{formatMessage({ id: 'need_help_title' })}
						</Typography>
						<Typography variant="subtitle2" color="grey.main" mb={3} textAlign="center">
							{formatMessage({ id: 'need_help_text' })}
						</Typography>
						{siteTelephone && (
							<Link underline="none" mb={4} href={`tel: ${siteTelephone}`} textAlign="center">
								<Typography variant="h4">{siteTelephone}</Typography>
							</Link>
						)}
						<AdditionalText variant="subtitle2" color="grey.main" textAlign="center">
							{formatMessage({ id: 'need_help_additional_text' })}
						</AdditionalText>
					</Grid>
				</DialogStyled>
			</>
		)
	)
}

export default NeedHelp
